import http from "./http";

const apiEndpoint = process.env.REACT_APP_BASE_URL + "/api/Emp";

export function getCurrUser() {
  return http.post(`${apiEndpoint}/GetCurrent`);
}

export function getAllEmp() {
  return http.post(`${apiEndpoint}/GetActiveSearchIgnoreCurrent`);
}

export async function getByMgrId() {
  const { data } = await http.post(`${apiEndpoint}/GetCurrent`);

  return http.post(`${apiEndpoint}/GetByMgrIdDropDown/?mgrId=${data?.data?.id}`);
}
